import React, { useEffect, useState } from "react";
import { authApiService } from "../../api/api";
import FilterBlock from "../../components/FilterBlock/FilterBlock";
import AddPhoneOrderBoxingModal from "../../components/modals/AddPhoneOrderBoxingModal/AddPhoneOrderBoxingModal";
import AddPhoneOrderModal from "../../components/modals/AddPhoneOrderModal/AddPhoneOrderModal";
import EditPhoneOrderModal from "../../components/modals/EditPhoneOrderModal/EditPhoneOrderModal";
import PhoneOrderFilterModal from "../../components/modals/filters/PhoneOrderFilterModal/PhoneOrderFilterModal";
import { SelectOption } from "../../components/modals/forms/inputs/SelectInput/SelectInput";
import Pagination from "../../components/pagination/Pagination/Pagination";
import PhoneOrderTable from "../../components/Tables/PhoneOrderTable";
import TableTitle from "../../components/TableTitle/TableTitle";
import { IClient } from "../../types/clients.type";
import { IPhoneOrder } from "../../types/phoneOrder.type";
import { IProduct } from "../../types/product.type";
import { usersPerPage } from "../../utils/constants/page";
import { filterPhoneOrder } from "../../utils/filterUsers";
import styles from "./styles.module.scss";

const PhoneOrdersPage: React.FC = () => {
  const [orders, setOrders] = useState<IPhoneOrder[]>([]);
  const [filteredOrders, setFilteredOrders] = useState<IPhoneOrder[]>([]);
  const [editSelectedOrder, setEditSelectedOrder] =
    useState<IPhoneOrder | null>(null);
  const [visibleOrders, setVisibleOrders] = useState<IPhoneOrder[]>([]);
  const [activePage, setActivePage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isFilterModal, setIsFilterModal] = useState<boolean>(false);
  const [selectedStatus, setSelectedStatus] = useState<SelectOption>({
    value: "none",
    label: "All",
  });
  const [selectedType, setSelectedType] = useState<SelectOption>({
    value: "none",
    label: "All",
  });
  const [selectStartDate, setSelectStartDate] = useState<Date | null>(null);
  const [selectEndDate, setSelectEndDate] = useState<Date | null>(null);
  const [isAddOrderModal, setIsAddOrderModal] = useState<boolean>(false);
  const [clients, setClients] = useState<IClient[]>([]);
  const [products, setProducts] = useState<IProduct[]>([]);
  const [addWithdraw, setAddWithdraw] = useState<IPhoneOrder | null>(null);

  const getOrders = async () => {
    try {
      const response = await authApiService.getAllPhoneOrders();
      if (response) {
        return response.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getClients = async () => {
    try {
      const response = await authApiService.getAllClients();
      if (response) {
        return response;
      }
    } catch (err) {
      console.error(err);
    }
  };
  const getProducts = async () => {
    try {
      const response = await authApiService.getAllProducts();
      if (response) {
        return response;
      }
    } catch (err) {
      console.error(err);
    }
  };

  const changeVisibiltyUser = (users: IPhoneOrder[]) => {
    const indexOfLastUser = activePage * usersPerPage;
    const indexOfFirstUser = indexOfLastUser - usersPerPage;
    if (users) {
      const changedUsers = users.slice(indexOfFirstUser, indexOfLastUser);
      setVisibleOrders(changedUsers);
    }
  };

  const getOptionsFilter = (
    type: SelectOption,
    status: SelectOption,
    startDate: Date | null,
    endDate: Date | null
  ) => {
    let filteredUsers = [...orders];
    setSelectedStatus(status);
    setSelectedType(type);
    setSelectStartDate(startDate);
    setSelectEndDate(endDate);

    if (status.value !== "none") {
      filteredUsers = filteredUsers.filter(
        (item) => item.status === status.value
      );
    }

    if (type.value !== "none") {
      filteredUsers = filteredUsers.filter((item) => item.type === type.value);
    }

    if (startDate) {
      filteredUsers = filteredUsers.filter(
        (item) => new Date(item.createdAt) >= new Date(startDate)
      );
    }

    if (endDate) {
      filteredUsers = filteredUsers.filter(
        (item) => new Date(item.createdAt) <= new Date(endDate)
      );
    }

    return filteredUsers;
  };

  const onFilterChange = (
    type: SelectOption,
    status: SelectOption,
    startDate: Date | null,
    endDate: Date | null
  ) => {
    const data = getOptionsFilter(type, status, startDate, endDate);
    const filteredUsers = filterPhoneOrder(data, searchValue);

    setFilteredOrders(filteredUsers);
  };

  const getFiltredUsers = () => {
    const data = getOptionsFilter(
      selectedType,
      selectedStatus,
      selectStartDate,
      selectEndDate
    );
    const filteredUsers = filterPhoneOrder(data, searchValue);
    setFilteredOrders(filteredUsers);
  };

  const onClickApplyModal = async () => {
    const resp = await getOrders();
    if (resp) {
      setOrders(resp);
      getFiltredUsers();
    }
  };

  useEffect(() => {
    setTotalPages(Math.ceil(filteredOrders.length / usersPerPage));
  }, [filteredOrders]);

  useEffect(() => {
    getFiltredUsers();
    // setActivePage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, orders]);

  useEffect(() => {
    (async () => {
      const data = await getOrders();
      if (data) {
        await setOrders(data);
      }
      const cli = await getClients();
      if (cli) {
        await setClients(cli);
      }
      const prod = await getProducts();
      if (prod) {
        await setProducts(prod);
      }
    })();
  }, []);

  useEffect(() => {
    changeVisibiltyUser(filteredOrders);
    // setTotalPages(Math.ceil(users.length / usersPerPage));
    if (activePage > totalPages) {
      if (activePage === 1) {
        setActivePage(1);
      } else {
        setActivePage(totalPages);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePage, orders, totalPages, filteredOrders]);

  return (
    <main className={styles.container}>
      <div className={styles.header}>
        <TableTitle title="Всі" count={orders?.length || 0} />
        <div>
          <FilterBlock
            searchValue={searchValue}
            onPressModal={() => setIsFilterModal(true)}
            onSearchChange={(value) => setSearchValue(value)}
            onPressAdd={() => setIsAddOrderModal(true)}
            addButtonTitle="Add order"
          />
        </div>
      </div>

      <PhoneOrderTable
        orders={visibleOrders}
        callBackEdit={setEditSelectedOrder}
        callBackAddWithdraw={setAddWithdraw}
      />
      <Pagination
        key={totalPages}
        count={totalPages}
        activePage={activePage}
        onClick={(page) => setActivePage(page)}
        onClickNext={() => setActivePage((prevState) => (prevState += 1))}
        onClickPrev={() => setActivePage((prevState) => (prevState -= 1))}
      />
      {editSelectedOrder && (
        <EditPhoneOrderModal
          order={editSelectedOrder}
          onClose={() => setEditSelectedOrder(null)}
          onApply={onClickApplyModal}
        />
      )}
      {isAddOrderModal && (
        <AddPhoneOrderModal
          onApply={onClickApplyModal}
          onClose={() => setIsAddOrderModal(false)}
          clients={clients}
          products={products}
        />
      )}
      {addWithdraw && (
        <AddPhoneOrderBoxingModal
          onClose={() => setAddWithdraw(null)}
          onApply={onClickApplyModal}
          order={addWithdraw}
          products={products}
        />
      )}

      {isFilterModal && (
        <PhoneOrderFilterModal
          onClose={() => setIsFilterModal(false)}
          onApply={onFilterChange}
          defaultType={selectedType}
          defultPaymentStatus={selectedStatus}
          defaultEndDate={selectEndDate}
          defaultStartDate={selectEndDate}
        />
      )}
    </main>
  );
};

export default PhoneOrdersPage;
